<div class="w-full">
  <div
    class="relative border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors duration-300 bg-gray-50 hover:border-metro-blue font-sans"
    [class.border-blue-500]="isDragOver"
    [class.bg-blue-50]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="triggerFileInput()"
  >
    @if(images.length === 0) {
      <div class="flex flex-col items-center justify-center space-y-4">
        <p class="text-gray-500 text-sm">{{ placeholderText | abpLocalization}}</p>
        <button
          type="button"
          class="px-2 py-1 text-xs bg-metro-blue text-metro-secondary font-sans rounded  transition"
        >
          {{ buttonText | abpLocalization }}
        </button>
      </div>
    }

    @if(images.length > 0) {
      <div class="flex flex-col items-center justify-center space-y-4">
        <div class="w-48 h-48 bg-white rounded-lg overflow-hidden flex items-center justify-center">
          <img [src]="images[0].url || 'assets/images/no-image.png'" [alt]="images[0].name"
            class="w-full h-full object-cover" (error)="onImageError($event)" />
        </div>

        <p class="text-gray-700 font-medium">{{ '::UploadedImagePreview' | abpLocalization }}</p>
        <button
          type="button"
          class="px-2 py-1 text-xs bg-metro-blue text-metro-secondary rounded transition"
          (click)="triggerFileInput(); $event.stopPropagation()"
        >
          {{ '::ChangeImage' | abpLocalization }}
        </button>
      </div>
    }
  </div>

  <input
    type="file"
    #fileInput
    [accept]="accept"
    [multiple]="multiple"
    (change)="onFileInput($event)"
    class="hidden"
  />

  @if(errorMessage) {
    <p class="text-red-500 mt-2 text-center text-sm">{{ errorMessage }}</p>
  }
</div>
